import React from 'react';
import { Image } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import aiLogo from '../../PINS_AI_Assistant_transparent.png';

const PINSAIAssistantLabel = ({ w = '200px', ...props }) => (
  <Image alt="PINS AI Assistant" src={aiLogo} width={w} {...props} />
);

PINSAIAssistantLabel.propTypes = { w: PropTypes.string };

export default PINSAIAssistantLabel;
